import { _ as _defineProperty } from '../_chunks/dep-6108ca17.js';
import Vue from 'vue';
import props from './props/props.js';
import ConfigContext from '../utils/config-context.js';
import useSizeProps from '../utils/use-size-props.js';
import { checkScriptAndLoad } from '../utils/check-url-and-load.js';
import '../style/css.js';
import '../utils/use-common-classname.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var classPrefix = ConfigContext.classPrefix;
var tName = "".concat(classPrefix, "-icon");
var CDN_ICONFONT_URL = "https://tdesign.gtimg.com/icon/0.4.4/fonts/index.js";
var _Icon = Vue.extend({
  name: "Icon",
  props: props,
  computed: {
    iconName: function iconName() {
      return this.url ? this.name : "".concat(tName, "-").concat(this.name);
    },
    classes: function classes() {
      var _useSizeProps = useSizeProps(this.size),
        sizeClassName = _useSizeProps.className;
      var iconName = this.url ? this.name : "".concat(tName, "-").concat(this.name);
      var arr = [tName, iconName, sizeClassName];
      return arr;
    },
    iconStyle: function iconStyle() {
      if (["small", "medium", "large"].includes(this.size)) return {};
      return {
        "font-size": this.size
      };
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      var _this$onClick;
      this.$emit("click", {
        e: e
      });
      (_this$onClick = this.onClick) === null || _this$onClick === void 0 ? void 0 : _this$onClick.call(this, {
        e: e
      });
    }
  },
  mounted: function mounted() {
    var finalUrl = [];
    if (this.url) {
      finalUrl = this.url instanceof Array ? this.url.concat() : [this.url];
    }
    if (this.loadDefaultIcons) {
      finalUrl.push(CDN_ICONFONT_URL);
    }
    Array.from(new Set(finalUrl)).forEach(function (url) {
      checkScriptAndLoad(url, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
    });
  },
  render: function render() {
    var h = arguments[0];
    var attrs = {
      href: "#".concat(this.iconName)
    };
    return h("svg", {
      "class": this.classes,
      "style": this.iconStyle,
      "on": {
        "click": this.handleClick
      }
    }, [h("use", {
      "attrs": _objectSpread({}, attrs)
    })]);
  }
});

export default _Icon;
//# sourceMappingURL=svg-sprite.js.map
